<!--  -->
<template>
  <div class="add_box">
    <div style="padding-left: 600px">
      <el-button type="primary" icon="el-icon-plus" circle @click="add" />
    </div>
    <div style="height: 500px; overflow-y: auto">
      <div>
        <ul>
          <li v-for="(item, index) in app_ids" :key="index">
            <div>
              <!-- <i :class="icontype" @click="iconshdow(1, index)" /> -->
              {{ item.corp_name }}
            </div>
            <ul>
              <li
                v-for="(dept, dIndex) in item.relation"
                :key="dIndex"
                style="padding-left: 15px; margin: 8px"
              >
                <div>
                  <i :class="dept.icon" @click="iconshow(2, index, dIndex)" />
                  {{ dept.dept_name }}
                  <div v-show="dept.iconshow !== 9" style="padding-left: 400px">
                    <el-button
                      v-if="dept.show !== 9"
                      size="mini"
                      type="danger"
                      icon="el-icon-edit"
                      circle
                      @click="edit(index, dIndex)"
                    />
                    <div v-else>
                      <el-button
                        size="mini"
                        :disabled="dept.tagshow !== 9"
                        type="danger"
                        @click="dlet(index, dIndex)"
                      >确定删除</el-button>
                      <el-button
                        size="mini"
                        type="danger"
                        @click="tagClose"
                      >取消</el-button>
                    </div>
                  </div>
                </div>
                <ul
                  v-show="dept.iconshow !== 9"
                  style="padding-left: 15px; padding-top: 10px"
                >
                  <li
                    v-for="(wechat, wIndex) in dept.wechat_account"
                    :key="wIndex"
                    style="margin: 3px; display: inline-block"
                  >
                    <div v-if="dept.show === 9" style="display: flex">
                      <el-tag
                        closable
                        @close="handleClose(wechat, index, dIndex, wIndex)"
                      >{{ wechat.wechat_name }}</el-tag>
                    </div>
                    <div v-else style="display: flex">
                      <el-tag>{{ wechat.wechat_name }}</el-tag>
                    </div>
                  </li>
                </ul>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
    <!-- <div style="float: right">
      <el-button type="primary" size="mini" @click="submit">确定</el-button>
    </div> -->
    <el-dialog
      title="新增"
      :close-on-click-modal="false"
      :visible.sync="dialogadd"
      width="800px"
      append-to-body
    >
      <appidCreat ref="appid" @callbackbacer="callbackbacer" />
    </el-dialog>
  </div>
</template>

<script>
import appidCreat from './appidCreat.vue'
import {
  get_yonyou_relation,
  set_yonyou_relationadd
} from '@/api/providerAccountManagement/servicePorviderList.js'
export default {
  components: { appidCreat },
  data() {
    return {
      dialogVisible: false,
      total: null,
      adtype: null,
      query: {
        page: 1,
        page_size: 10,
        orgunit_id: null,
        orgunit_code: null,
        orgunit_name: null
      },
      tableData: [],
      app_ids: [],
      datas: {},
      dialogadd: false,
      initappid: [],
      icontype: 'el-icon-caret-bottom'
    }
  },
  created() {},
  mounted() {},
  methods: {
    iconshow(type, index, dIndex) {
      console.log('index,dIndex:', index, dIndex)
      if (this.app_ids[index].relation[dIndex].icon === 'el-icon-caret-right') {
        this.app_ids[index].relation[dIndex].icon = 'el-icon-caret-bottom'

        this.app_ids[index].relation[dIndex].iconshow = 8
      } else {
        this.app_ids[index].relation[dIndex].icon = 'el-icon-caret-right'
        this.app_ids[index].relation[dIndex].iconshow = 9
      }
      console.log(this.app_ids)
      this.$forceUpdate()
    },
    tagClose() {
      this.app_ids = JSON.parse(JSON.stringify(this.initappid))
      console.log('this.ini', this.app_ids, this.initappid)
      this.$forceUpdate()
    },
    submit() {
      const extractedWechatAccounts = []
      this.app_ids.forEach((item) => {
        item.relation.forEach((dept) => {
          console.log('dept.wechat_account:', dept.wechat_account)
          if (dept.wechat_account.length !== 0) {
            dept.wechat_account.forEach((wechat) => {
              extractedWechatAccounts.push(wechat)
            })
          }
        })
      })
      console.log(extractedWechatAccounts)
      this.$emit('bandarr', extractedWechatAccounts)
    },
    handleClose(wechat, index, dIndex, wIndex) {
      const wechatAccount = this.app_ids[index].relation[dIndex].wechat_account
      // 找到要删除的 wechat 对象在数组中的索引
      const deleteIndex = wechatAccount.findIndex((item) => item === wechat)
      // 如果找到了要删除的对象
      if (deleteIndex !== -1) {
        // 从数组中删除该对象
        this.app_ids[index].relation[dIndex].wechat_account.splice(
          deleteIndex,
          1
        )
        console.log('wechatAccount:', wechatAccount)
      }
      this.app_ids[index].relation[dIndex].tagshow = 9
    },
    edit(index, dIndex) {
      this.app_ids[index].relation[dIndex].show = 9
      this.$forceUpdate()
    },
    dlet(index, dIndex) {
      const missingWechats = []

      const arrMap = new Map(
        this.app_ids[index].relation[dIndex].wechat_account.map((item) => [
          item.app_id,
          item.wechat_name
        ])
      )
      console.log('arrMap:', arrMap)

      this.initappid[index].relation[dIndex].wechat_account.forEach((item) => {
        if (
          !arrMap.has(item.app_id) ||
          arrMap.get(item.app_id) !== item.wechat_name
        ) {
          missingWechats.push(item)
        }
      })

      console.log(missingWechats)
      const obj = {
        orgunit_code: this.app_ids[index].corp_code,
        id: this.datas.id,
        dept_code: this.app_ids[index].relation[dIndex].dept_code,
        app_ids: missingWechats.map((v) => v.app_id),
        action: 'delete'
      }
      this.$confirm('确定删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async() => {
        await this.callbackbacer(obj)
        this.$message({
          type: 'success',
          message: '删除成功!'
        })
      })
      // this.app_ids[index].relation[dIndex].show = 8
      // this.$forceUpdate()
    },
    async callbackbacer(item) {
      console.log('item:', item)
      await set_yonyou_relationadd(item)
      this.dialogadd = false
      this.getappid()
    },
    add() {
      this.dialogadd = true
      this.$nextTick(() => {
        this.$refs.appid.sendr(this.datas.id, this.datas, 1)
      })
    },
    async getappid() {
      const res = await get_yonyou_relation({ id: this.datas.id })
      console.log('res:', res)
      this.app_ids = res.data.map((item) => {
        item.relation.forEach((relationItem) => {
          relationItem.icon = 'el-icon-caret-bottom'
        })
        return item
      })
      this.initappid = JSON.parse(JSON.stringify(this.app_ids))
    },
    sendr(item) {
      this.datas = item
      // this.query.orgunit_name = orgunit_name
      console.log(444, item)
      this.getappid()
    },
    chooser(item) {
      console.log(item)
      this.$emit('bandarr', item)
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.add_box {
  padding: 20px;
  width: 700px;
}
.defaultrse {
  color: #e6a23c;
}
.defaultr {
  color: #67c23a;
}
.stopew {
  color: red;
}
.fasrw {
  color: #409eff;
}
.sarch_box {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.sedrtw {
  width: 180px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  margin: 0 auto;
}
.sedrtwr {
  width: 380px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  margin: 0 auto;
}
</style>
